// Hooks
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';
import { AmbassadorRecord } from '@amzn/red-velvet-api';

const QUERY_PREFIX = ['RedVelvetApi', 'getAmbassadors'];

export function useGetAmbassadors(): UseQueryResult<AmbassadorRecord[]> {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useQuery({
    queryKey: QUERY_PREFIX,
    queryFn: async () => {
      const response = await client.getAmbassadors();
      if (response.ambassadors.length) {
        return response.ambassadors;
      } else {
        return [];
      }
    },
  });
}
